<template>
    <div>
        <b-modal
            size="md"
            v-model="modalShow"
            title="クレジットカードを削除"
            ok-title="削除する"
            ok-variant="danger"
            cancel-title="キャンセル"
            cancel-variant="yokumiru-gray"
            :ok-disabled="inProgress"
            :cancel-disabled="inProgress"
            @ok="handleOk"
            @cancel="close"
            @hidden="close">
            <div v-if="card" class="d-flex justify-content-center">
                <div class="pt-2">
                    <hr>
                    <dl class="d-flex align-items-center">
                        <dt style="width: 104px;">カード番号</dt>
                        <dd class="mb-0">{{ card.last4 }}</dd>
                    </dl>
                    <hr>
                    <dl class="d-flex align-items-center">
                        <dt style="width: 104px;">有効期限</dt>
                        <dd class="mb-0">{{ `${card.exp_year}年${card.exp_month}月` }}</dd>
                    </dl>
                    <hr>
                    <dl class="d-flex align-items-center">
                        <dt style="width: 104px;">カード名義</dt>
                        <dd class="mb-0">{{ card.name }}</dd>
                    </dl>
                    <hr>

                    <p class="text-center pt-2">上記のクレジットカードを削除します。<br>よろしいですか？</p>
                </div>
            </div>
        </b-modal>
    </div>
</template>

<script>
    import constants from '../../../constants'

    export default {
        name: "DestroyCreditCardModal",

        data: function() {
            return {
                modalShow: false,
                card: null,
                inProgress :false,
                errors: {},
            }
        },

        created: function () {
            bus.$on('open-modal-destroy-credit-card', this.open)
        },

        beforeDestroy: function () {
            bus.$off('open-modal-destroy-credit-card')
        },

        methods: {
            open: async function (card) {
                this.card = card
                this.modalShow = true
            },

            handleOk(e) {
                e.preventDefault()
                this.destroy()
            },

            destroy: async function () {
                if (this.inProgress) return
                this.inProgress = true

                if (!this.intent) {
                    await axios.delete(`${constants.user.credit_cards.endpoint.base}/${this.card.id}`)
                        .then(() => {
                            bus.$emit('credit-card-destroyed')
                            bus.$emit('alert-success', 'カードを削除しました。')
                            this.close()
                        })
                        .catch(({response}) => {
                            if (response &&
                                response.hasOwnProperty('data') &&
                                response.data.hasOwnProperty('errors') &&
                                response.data.errors.hasOwnProperty('message')) {
                                bus.$emit('alert-danger', response.data.errors.message[0])
                            }
                            else {
                                bus.$emit('alert-danger', 'システムエラーが発生しました。')
                            }
                        })
                }

                this.inProgress = false
            },

            close: function () {
                this.initialize()
                this.modalShow = false
            },

            initialize: function() {
                this.errors = {}
            },
        },
    }
</script>
